import { render, staticRenderFns } from "./InputAvatar.vue?vue&type=template&id=037267c7&scoped=true&"
import script from "./InputAvatar.vue?vue&type=script&lang=js&"
export * from "./InputAvatar.vue?vue&type=script&lang=js&"
import style0 from "./InputAvatar.vue?vue&type=style&index=0&id=037267c7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "037267c7",
  null
  
)

export default component.exports